import React from "react";
import "./GalleryContent.css";

const GalleryContent = ({ gallery }) => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  if (!Object.keys(gallery).length) return null;

  const getDescription = () => {
    if (gallery?.excerpt?.rendered && gallery.excerpt.rendered.trim() !== "") {
      return gallery.excerpt.rendered;
    }

    if (gallery?.content?.rendered) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = gallery.content.rendered;
      const firstParagraph = tempDiv.querySelector("p");
      return firstParagraph ? firstParagraph.outerHTML : "";
    }

    return "";
  };

  return (
    <>
      <section className="bg-white md:py-16 py-8">
        <div className="container mx-auto md:px-0 px-8">
          <div className="text-base md:w-10/12 w-full">
            <div class="flex">
              <img
                class="mr-5 h-12 -mt-2"
                src="/images/electric-bolt-solid.svg"
                alt="Nant Power Project Icon"
              />
              <div class="text-xl font-bold text-gray-500">
                <span>Gallery</span>
              </div>
            </div>
            <div className="text-base w-full md:px-14 px-0 mt-0">
              <h1 className="leading-7 text-[#0070b9] pb-2 md:mr-5 mr-0 md:text-4xl text-3xl font-semibold">
                <div
                  dangerouslySetInnerHTML={{
                    __html: gallery?.title?.rendered,
                  }}
                />
              </h1>
              {gallery?.date && (
                <div class="text-lg mb-2 text-[#58b947] font-medium">
                  <span>
                    {monthNames[new Date(gallery?.date).getMonth()] +
                      " " +
                      new Date(gallery?.date).getFullYear()}
                  </span>
                </div>
              )}
              {getDescription() && (
                <p
                  className="text-xl"
                  dangerouslySetInnerHTML={{
                    __html: getDescription(),
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="relative xl:p-0 p-8">
        <div id="gallery-content" className="container mx-auto pb-16">
          <div
            dangerouslySetInnerHTML={{
              __html: gallery?.content?.rendered.replace(
                "<img",
                "<div style=\"position: 'absolute'; top: 0; left: 0; width: '100%'; height: '100%'; backgroundColor: 'rgba(255, 255, 255, 0)';zIndex: 1\" ></div><img",
              ),
            }}
          />
        </div>
      </section>
    </>
  );
};

export default GalleryContent;
